import React from 'react';
import { Stack, Typography } from '@mui/material';
import { BRAND } from '../../theme/brandTokens';

const DashboardMetricValue = ({ value, caption, emphasis = false }) => (
  <Stack spacing={0.5}>
    <Typography
      sx={{
        fontWeight: 800,
        color: BRAND.text,
        fontSize: emphasis ? { xs: '2rem', sm: '2.5rem' } : { xs: '1.75rem', sm: '2rem' },
        lineHeight: 1.1,
        fontVariantNumeric: 'tabular-nums',
      }}
    >
      {value}
    </Typography>
    {caption && (
      <Typography variant="caption" sx={{ color: BRAND.textMuted }}>
        {caption}
      </Typography>
    )}
  </Stack>
);

export default DashboardMetricValue;
